"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const provider_specialties_styles_1 = require("./provider-specialties.styles");
const with_error_boundary_1 = require("../ErrorFallback/with-error-boundary");
const utils_1 = require("../../lib/utils");
const ProviderSpecialties = ({ provider }) => {
    const specialtiesItems = (0, utils_1.getSpecialtyItems)(provider);
    if (specialtiesItems.length > 0) {
        return (react_1.default.createElement(react_1.default.Fragment, null, specialtiesItems.map((item, index) => (react_1.default.createElement(provider_specialties_styles_1.ProviderSpecialtiesListItem, { key: item.toString() + index, itemProp: "medicalSpecialty" }, item)))));
    }
    return null;
};
exports.default = (0, with_error_boundary_1.withErrorBoundary)(ProviderSpecialties);
//# sourceMappingURL=provider-specialties.js.map